import React, { useState, useEffect, memo } from 'react'
import { withTranslation, useTranslation } from 'react-i18next'
import { Box } from '@material-ui/core'
import Typography from '../../atoms/display/typography'
import { useDispatch, useSelector } from 'react-redux'
import { useTheme } from '@material-ui/core/styles'
import useStyles from './accordionMasterComponentDetails.js'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core'
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons'

import RenderAccordionDetails from '../../molecules/ticket/accordionDetails'
import RenderHorizontalStepper from '../../molecules/ticket/stepperHorizontal'
import RenderVerticalStepper from '../../molecules/ticket/stepperVertical'
import RenderFiles from '../../molecules/ticket/filesComponent'
import RenderFormData from '../../molecules/ticket/formDetails'
import messages from '../../../services/messages'
import CircularProgress from '../../atoms/feedback/circularProgress'
import { setAccordion } from '../../../redux/ticket/actions'
import InteractionsComponent from './interactions'

const RenderAccordionParent = ({
  parent,
  small,
  conversation,
  historic = false,
  consumerId,
  channel,
}) => {
  let accordion = useSelector((state) => state.accordionValue)

  let tempAccordionValues = {
    processData: false,
    journeyDetails: false,
    attachedDocuments: false,
    formData: false,
  }

  const [status, setStatus] = useState(false)
  const [historicChat, setHistoricChat] = useState(null)
  const size = useSelector((state) => state.preferences)

  let useStylesParams = {
    size: size,
  }

  const classes = useStyles(useStylesParams)

  const theme = useTheme()

  const { t } = useTranslation()

  const [accordionChild, setAccordionChild] = useState({})

  const dispatch = useDispatch()

  const handleClick = (property) => {
    if (typeof accordion[conversation?.conversationId] !== 'undefined') {
      tempAccordionValues = accordion[conversation?.conversationId]
      tempAccordionValues[property] =
        accordion[conversation?.conversationId][property] === true
          ? false
          : true
    }
    dispatch(
      setAccordion({
        ...accordion,
        [conversation?.conversationId]: tempAccordionValues,
      })
    )
  }

  useEffect(() => {
    setHistoricChat(null)
  }, [conversation])

  useEffect(() => {
    if (typeof accordion[conversation?.conversationId] === 'undefined') {
      dispatch(
        setAccordion({
          ...accordion,
          [conversation?.conversationId]: tempAccordionValues,
        })
      )
    }
    if (historic) {
      getChatHistory(consumerId, channel)
    }
  }, [conversation, historic])

  const getChatHistory = async (consumerId, channel) => {
    try {
      const response = await messages.get(
        `/tech4h-messages/consumer/${consumerId}/conversations/${channel}`
      )
      if (response.status === 200) {
        let message = response?.data?.message
        let chats = response?.data?.data?.reduce((chats, chat) => {
          return { ...chats, [chat.conversationId]: chat }
        }, {})
        setHistoricChat(chats)
        setStatus(true)
      } else {
        throw response.data
      }
    } catch (error) {
      let message =
        error?.response?.status === 500
          ? 'Unavailable service'
          : error?.response?.data?.message
    }
  }

  return parent ? (
    <div style={{ margin: '1.25em' }}>
      <Accordion
        onChange={(e, expanded) => {
          handleClick('processData')
        }}
        expanded={
          typeof accordion?.[conversation?.conversationId]?.processData ===
          'undefined'
            ? false
            : accordion?.[conversation?.conversationId]?.processData
        }
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: '#fff' }} />}
          aria-controls="panel1a-content"
          className={classes.panelHeader}
          id="panel-header"
          style={{
            background:
              theme.palette.type === 'dark'
                ? theme.palette.primary.main
                : '#172746',
            marginTop: 10,
          }}
        >
          <Typography style={{ color: '#fff' }}>
            {t('commons.processData')}
          </Typography>
        </AccordionSummary>

        <AccordionDetails style={{ flexDirection: 'column' }}>
          <RenderAccordionDetails
            history={conversation?.ticket?.processData}
            conversation={conversation}
          />
          <RenderHorizontalStepper
            history={conversation?.ticket?.processData}
            horizontalValue={1}
          />
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={
          typeof accordion?.[conversation?.conversationId]?.journeyDetails ===
          'undefined'
            ? false
            : accordion?.[conversation?.conversationId]?.journeyDetails
        }
        onChange={() => {
          handleClick('journeyDetails')
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: '#fff' }} />}
          aria-controls="panel1a-content"
          className={classes.panelHeader}
          id="panel-header-vertical-stepper"
          style={{
            background:
              theme.palette.type === 'dark'
                ? theme.palette.primary.main
                : '#172746',
            marginTop: 10,
          }}
        >
          <Typography style={{ color: '#fff' }}>
            {t('commons.journeyDetails')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <RenderVerticalStepper
            history={conversation?.ticket}
          ></RenderVerticalStepper>
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={
          typeof accordion?.[conversation?.conversationId]
            ?.attachedDocuments === 'undefined'
            ? false
            : accordion?.[conversation?.conversationId]?.attachedDocuments
        }
        onChange={(e, expanded) => {
          handleClick('attachedDocuments')
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: '#fff' }} />}
          aria-controls="panel1a-content"
          className={classes.panelHeader}
          id="panel-header-vertical-stepper"
          style={{
            background:
              theme.palette.type === 'dark'
                ? theme.palette.primary.main
                : '#172746',
            marginTop: 10,
          }}
        >
          <Typography style={{ color: '#fff' }}>
            {t('commons.attachedDocuments')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <RenderFiles
            history={conversation?.ticket?.documentsAttached}
            small={small}
          />
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={
          typeof accordion?.[conversation?.conversationId]?.formData ===
          'undefined'
            ? false
            : accordion?.[conversation?.conversationId]?.formData
        }
        onChange={(e, expanded) => {
          handleClick('formData')
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: '#fff' }} />}
          aria-controls="panel1a-content"
          className={classes.panelHeader}
          id="panel-header-vertical-stepper"
          style={{
            background:
              theme.palette.type === 'dark'
                ? theme.palette.primary.main
                : '#172746',
            marginTop: 10,
          }}
        >
          <Typography style={{ color: '#fff' }}>
            {t('commons.formData')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <RenderFormData
            history={conversation?.ticket?.formData}
            small={small}
          />
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={!!accordion?.[conversation?.conversationId]?.interactions}
        onChange={(e, expanded) => {
          handleClick('interactions')
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: '#fff' }} />}
          aria-controls="panel1a-content"
          className={classes.panelHeader}
          id="panel-header-vertical-stepper"
          style={{
            background:
              theme.palette.type === 'dark'
                ? theme.palette.primary.main
                : '#172746',
            marginTop: 10,
          }}
        >
          <Typography style={{ color: '#fff' }}>
            {t('commons.HistoryInteractions')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <InteractionsComponent />
        </AccordionDetails>
      </Accordion>
    </div>
  ) : (
    <div style={{ margin: '1.25em' }}>
      {historicChat === null && (
        <Box>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '1em',
            }}
          >
            <CircularProgress size={50} />
          </div>
        </Box>
      )}
      {status && (
        <div>
          {historicChat !== null && Object.keys(historicChat)?.length === 0 && (
            <Box>
              <h1 style={{ textAlign: 'center' }}>
                {t('commons.thereIsNoHistoryForThisService')}
              </h1>
            </Box>
          )}
          {historicChat !== null &&
            Object.keys(historicChat).map((history, idx) => (
              <Box>
                <div className={classes.transferHistory}>
                  <RenderAccordionDetails
                    history={historicChat[history]?.ticketInfo?.processData}
                    conversation={conversation}
                    historic={true}
                  />
                  <RenderHorizontalStepper
                    parent={false}
                    history={historicChat[history]?.ticketInfo?.processData}
                    horizontalValue={idx}
                  />
                  <div className={classes.accordionReverse}>
                    <Accordion
                      onChange={(e, expanded) => {
                        if (expanded) {
                          setAccordionChild((prev) => ({
                            ...prev,
                            [idx]: true,
                          }))
                        } else {
                          setAccordionChild((prev) => ({
                            ...prev,
                            [idx]: false,
                          }))
                        }
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon style={{ color: '#fff' }} />
                        }
                        aria-controls="panel1a-content"
                        className={classes.panelHeader}
                        id="panel-header-vertical-stepper"
                        style={{
                          background:
                            theme.palette.type === 'dark'
                              ? theme.palette.primary.main
                              : '#172746',
                          marginTop: 10,
                        }}
                      >
                        <Typography style={{ color: '#fff' }}>
                          {accordionChild[idx] === true
                            ? t('commons.hideAll')
                            : t('commons.seeAll')}
                        </Typography>
                      </AccordionSummary>

                      <Accordion defaultExpanded={true}>
                        <AccordionSummary
                          expandIcon={
                            <ExpandMoreIcon style={{ color: '#fff' }} />
                          }
                          aria-controls="panel1a-content"
                          className={classes.panelHeader}
                          id="panel-header-vertical-stepper"
                          style={{
                            background:
                              theme.palette.type === 'dark'
                                ? theme.palette.primary.main
                                : '#172746',
                            marginTop: 10,
                          }}
                        >
                          <Typography style={{ color: '#fff' }}>
                            {t('commons.journeyDetails')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <RenderVerticalStepper
                            history={historicChat[history]?.ticketInfo}
                          />
                        </AccordionDetails>
                      </Accordion>
                      <Accordion defaultExpanded={true}>
                        <AccordionSummary
                          expandIcon={
                            <ExpandMoreIcon style={{ color: '#fff' }} />
                          }
                          aria-controls="panel1a-content"
                          className={classes.panelHeader}
                          id="panel-header-vertical-stepper"
                          style={{
                            background:
                              theme.palette.type === 'dark'
                                ? theme.palette.primary.main
                                : '#172746',
                            marginTop: 10,
                          }}
                        >
                          <Typography style={{ color: '#fff' }}>
                            {t('commons.attachedDocuments')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <RenderFiles
                            history={
                              historicChat[history]?.ticketInfo
                                ?.documentsAttached
                            }
                            small={small}
                          />
                        </AccordionDetails>
                      </Accordion>

                      <Accordion defaultExpanded={true}>
                        <AccordionSummary
                          expandIcon={
                            <ExpandMoreIcon style={{ color: '#fff' }} />
                          }
                          aria-controls="panel1a-content"
                          className={classes.panelHeader}
                          id="panel-header-vertical-stepper"
                          style={{
                            background:
                              theme.palette.type === 'dark'
                                ? theme.palette.primary.main
                                : '#172746',
                            marginTop: 10,
                          }}
                        >
                          <Typography style={{ color: '#fff' }}>
                            {t('commons.formData')}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <RenderFormData
                            history={
                              historicChat[history]?.ticketInfo?.formData
                            }
                            small={small}
                          />
                        </AccordionDetails>
                      </Accordion>
                    </Accordion>
                  </div>
                </div>
              </Box>
            ))}
        </div>
      )}
    </div>
  )
}

export default withTranslation()(memo(RenderAccordionParent))
